export default "__VITE_PUBLIC_ASSET__73ed4b3f__"